import { useCallback } from 'react';
import { useLazyQuery } from '@apollo/client';

import { ResumeDownloadQuery } from 'core/operations';
import { Languages } from 'context';

type DownloadCv = [
  (language: Languages) => void,
  {
    loading: boolean;
    error: boolean;
  },
];

/**
 * Triggers the server-rendered CV PDF download (spec 0018, increment B).
 *
 * Unchanged endpoint: the `apollo-link-rest` `restLink` still points at
 * `/resume/download_resume` (the backend now renders it from the career profile).
 * Only the language set expands to RUS / ENG / POL. `no-cache` so the same
 * language can be re-downloaded.
 */
export const useDownloadCv = (): DownloadCv => {
  const [download, { loading, error }] = useLazyQuery(ResumeDownloadQuery, {
    fetchPolicy: 'no-cache',
  });

  const downloadCv = useCallback(
    (language: Languages) => download({ variables: { language } }),
    [download],
  );

  return [downloadCv, { loading, error: Boolean(error) }];
};
